module.exports = __webpack_public_path__ + "img/takahashi-name-logo.07ae00b9.png";